import { render, staticRenderFns } from "./email-verification.html?vue&type=template&id=47bfdb4c&scoped=true&"
import script from "./email-verification.js?vue&type=script&lang=js&"
export * from "./email-verification.js?vue&type=script&lang=js&"
import style0 from "./email-verification.scss?vue&type=style&index=0&id=47bfdb4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bfdb4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VIcon,VSpacer})
